module.exports = __webpack_public_path__ + "img/56.6c9acf11.png";